import { ss } from '@/utils/storage'

const LOCAL_NAME = 'userStorage'

export interface UserState {
  userInfo: Auth.userInfo
  workSpace: string | null
  workSpaceId: number | null
  workSpaceLogo: string | null
  canEdit: boolean
  role: any
  grading_scale: number | null
  type: string | null
  showRequestWorkspace: boolean
  isFirstLogin: boolean
}

export function defaultSetting(): UserState {
  return {
    userInfo: {},
    workSpace: '',
    workSpaceId: 0,
    workSpaceLogo: '',
    canEdit: false,
    role: null,
    grading_scale: 10,
    type: null,
    showRequestWorkspace: false,
    isFirstLogin: false,
  }
}

export function getLocalState(): UserState {
  const localSetting: UserState | undefined = ss.get(LOCAL_NAME)
  return { ...defaultSetting(), ...localSetting }
}

export function setLocalState(setting: UserState): void {
  ss.set(LOCAL_NAME, setting)
}
